import Page from "components/common/page/Page"

const AgricultureInvestmentHomePage = () => {
    return (
        <Page title="pages.agriculture.work.investment.home">
            <div>Investments</div>
        </Page>
    );
};

export default AgricultureInvestmentHomePage;
